import './App.css';
import Main from './component/Main';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
// echo "# Moaz_Tello_Image_Idetor" >> README.md
// git init
// git add README.md
// git commit -m "first commit"
// git branch -M main
// git remote add origin https://github.com/eng-moaz-tello/Moaz_Tello_Image_Idetor.git
// git push -u origin main
// git init

// git remote add origin https://github.com/eng-moaz-tello/Moaz_Tello_Image_Idetor.git
// git branch -M main
// git push -u origin main
// https://github.com/eng-moaz-tello/Moaz_Tello_Image_Idetor.git